<h1>Gear upgrade calculator</h1>

<div class="result-wrapper">
  <div class="side-panel-container">
    <div class="form-container">
      <h2>Data:</h2>
      <div class="input-container">
        <label class="input-label" for="simulation-count">Simulate X times</label>
        <input
          id="simulation-count"
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="simulationCount"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="fwc-button-button">FWC</label>
        <mat-slide-toggle
          id="fwc-button"
          class="checkbox-input"
          [(ngModel)]="priceProvider.isFwc"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="pd12-button-button">Pd12</label>
        <mat-slide-toggle
          id="pd12-button"
          class="checkbox-input"
          [(ngModel)]="isPd12"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="upgrade-event-button-button">Upgrade event</label>
        <mat-slide-toggle id="upgrade-event-button" class="checkbox-input" [(ngModel)]="isUpgradeEvent" />
      </div>
      <div class="input-container">
        <label class="input-label" for="custom-upgrade-bonus">Upgrade bonus %</label>
        <input
          id="custom-upgrade-bonus"
          class="data-input"
          type="number"
          [min]="0"
          [max]="9999"
          [(ngModel)]="customUpgradeBonus"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="current-upgrade">Current upgrade level</label>
        <input
          id="current-upgrade"
          class="data-input"
          type="number"
          [min]="0"
          [max]="9"
          [(ngModel)]="currentUpgrade"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="target-upgrade">Target upgrade level</label>
        <input
          id="target-upgrade"
          class="data-input"
          type="number"
          [min]="1"
          [max]="10"
          [(ngModel)]="targetUpgrade"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="current-attempts">Current attempts</label>
        <input
          id="current-attempts"
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="currentAttemptsIn"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="use-lows-until">Use sPro low until level</label>
        <input
          id="use-lows-until"
          class="data-input"
          type="number"
          [min]="0"
          [max]="10"
          [(ngModel)]="useLowsUntil"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="spro-cost">sPro cost</label>
        <input
          id="spro-cost"
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.sProPrice"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="spro-low-cost">sPro low cost</label>
        <input
          id="spro-low-cost"
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.sProLowPrice"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="eron-cost">Eron cost</label>
        <input
          id="eron-cost"
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.eronPrice"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="mineral-cost">Mineral cost</label>
        <input
          id="mineral-cost"
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.mineralPrice"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="pd4-cost">pd4 cost</label>
        <input
          id="pd4-cost"
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.pd4Price"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="pd6-cost">pd6 cost</label>
        <input
          id="pd6-cost"
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.pd6Price"
        />
      </div>
      <div class="button-container">
        <button (click)="SimulateUpgrading()">Calculate</button>
      </div>
    </div>
    <div class="result-container">
      <h2>Results:</h2>
      <div class="results">
        <div class="result-row">
          <p class="bold">Total penya cost:&nbsp;</p>
          <p>{{ GetTotalPenyaCost() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <br />
        <div class="result-row">
          <p class="bold">Total sPro cost:&nbsp;</p>
          <p>
            {{
              (GetSprosUsed() * priceProvider.sProPrice + GetSproLowsUsed() * priceProvider.sProLowPrice) /
                simulationCount | number : "1.0-1"
            }}
          </p>
        </div>
        <div class="result-row">
          <p class="bold">Total sPro's used:&nbsp;</p>
          <p>{{ GetSprosUsed() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <div class="result-row">
          <p class="bold">Total sPro low's used:&nbsp;</p>
          <p>{{ GetSproLowsUsed() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <br />
        <div class="result-row">
          <p class="bold">Total material cost:&nbsp;</p>
          <p>
            {{
              (GetEronsUsed() * priceProvider.eronPrice + GetMineralsUsed() * priceProvider.mineralPrice) /
                simulationCount | number : "1.0-1"
            }}
          </p>
        </div>
        <div class="result-row">
          <p class="bold">Total erons used:&nbsp;</p>
          <p>{{ GetEronsUsed() / simulationCount | number : "1.0-0" }}</p>
        </div>
        <div class="result-row">
          <p class="bold">Total minerals used:&nbsp;</p>
          <p>{{ GetMineralsUsed() / simulationCount | number : "1.0-0" }}</p>
        </div>
        <br />
        <div class="result-row">
          <p class="bold">Total dice cost:&nbsp;</p>
          <p>
            {{
              (GetPd4sUsed() * priceProvider.pd4Price + GetPd6sUsed() * priceProvider.pd6Price) /
                simulationCount | number : "1.0-1"
            }}
          </p>
        </div>
        <div class="result-row">
          <p class="bold">Total pd4's used:&nbsp;</p>
          <p>{{ GetPd4sUsed() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <div class="result-row">
          <p class="bold">Total pd6's used:&nbsp;</p>
          <p>{{ GetPd6sUsed() / simulationCount | number : "1.0-1" }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="upgrade-chart">
    <canvas id="upgrade-data-chart"></canvas>
  </div>
</div>
